import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Washington.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol for Software Development in Washington DC?
            </h2>
            <p>
              TekRevol’s software development services in Washington DC deliver
              a unique blend of innovation and local insight, providing custom
              software solutions crafted for your success. Our agile development
              approach ensures swift iterations, fast results, and compliance to
              evolving requirements. We offer profitable solutions without
              neglecting quality, making software development reachable to
              businesses of all sizes. We promote transparency and clear
              communication, keeping you informed at every stage of the
              development phase. Our commitment goes beyond deployment,
              delivering ongoing maintenance and support to guarantee faultless
              app operation. Choose TekRevol as your software partner in
              Washington DC, and experience customized excellence that sets your
              project apart.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
